import OS from "../appBar/components/OS_Logo_2.png";
import './LoginLoading.css';

export default function LoginLoading() {
  return (
    <div className="loading-container">
        <img src={OS} alt="loading" />
    </div>
  );
}